import { parseTagData } from "components/Blog/utils/Blog.utils"
import React from "react"
import type {
  BlogV2ArticleType,
  BlogV2TagParsed,
  ReducedBlogV2ArticleType,
} from "types/blog-v2-types"
import { isBlogPostV2Flat } from "types/typeGuards"
import { BlogArticleCard } from "../../../../../../../components/Blog/SharedComponents/BlogArticleCard"
import { BlogArticleCardV2 } from "packages/acquisition/pages/blog/components/Shared/BlogArticleCard"

import { container, postsContainer } from "./PostsGrid.css"

type Props = {
  posts: BlogV2ArticleType[] | ReducedBlogV2ArticleType[]
  tagDetails?: BlogV2TagParsed
}

export const PostsGrid: React.FC<Props> = ({ posts, tagDetails }) => (
  <div className={container}>
    <div className={postsContainer}>
      {posts.map((post) => {
        if (isBlogPostV2Flat(post)) {
          return (
            <BlogArticleCardV2
              key={post.slug}
              article={post}
              desktopCols={2}
              headingSize="h3"
            />
          )
        }
        return (
          <BlogArticleCard
            key={post.slug}
            post={post}
            tag={tagDetails || parseTagData(post.tags[0])}
            desktopCols={2}
            headingSize="h3"
          />
        )
      })}
    </div>
  </div>
)
